// extracted by mini-css-extract-plugin
export default {"root":"sR1W7T"};